
import React from 'react';

const ExperiencePersonHero = () => {

    
    return (
        <div className="text-center text-[#0E286C] my-[70px]">
            <p className="  font-semibold text-base">Advice</p>
            <h1 className="text-[48px] my-5 font-bold">Explore Further</h1>
            <p className="text-lg font-normal">Find more advice posts here</p>
         
        </div>
    );
};

export default ExperiencePersonHero;